angular.module('leanlaw').directive('llBillingAddress', [function () {
  return {
    restrict: 'EA',
    template: "<span ng-repeat='line in lines track by $index'>{{line}}<br/></span>",
    scope: {
      address: '=ngModel'
    },
    controller: ['$scope', function ($scope) {
      $scope.$watch('address.formatted', function (formatted) {
        $scope.lines = formatted ? formatted.split('\n') : [];
      });
    }]
  };
}]);